module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjIwMSIgdmlld0JveD0iMCAwIDMwMSAyMDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjRUQxQzI0IiBkPSJNLjUuNWgzMDB2MjAwSC41eiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0uNSAzMy44MzNoMzAwdjEzMy4zMzNILjV6Ii8+PHBhdGggZmlsbD0iIzI0MUQ0RiIgZD0iTS41IDY3LjE2NmgzMDB2NjYuNjY3SC41eiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-th.svg
// module id = F6SH
// module chunks = 2